<template>
  <v-dialog v-model="show" width="500">
    <v-card>
      <v-card-title>
        <span class="headline">請求用諸掛明細出力</span>
      </v-card-title>
      <v-card-actions>
        <v-btn :disabled="!allChoiced" @click="submit">{{$t('app.buttons.export')}}</v-btn>
        <v-btn @click="show=false">{{$t('app.buttons.back')}}</v-btn>
      </v-card-actions>
      <v-card-text>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex xs12>
              <v-layout row wrap>
                <v-flex md12>
                  <date-picker label="月次" type="month" v-model="query.yearMonth"></date-picker>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data() {
    return {
      show: false,
      query: {
        yearMonth: null
      },
      resolve: null,
      reject: null
    }
  },
  computed: {
    allChoiced() {
      return this.query.yearMonth != null
    }
  },
  methods: {
    popup() {
      this.show = true
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    submit() {
      this.show = false
      this.resolve(this.query)
    }
  }
}
</script>
